// Smart Sash Admin Panel - Sidebar Component
// Side navigation menu with role-based filtering

import React from 'react';
import { NavLink } from 'react-router-dom';
import { usePermissions } from '@/hooks';

interface SidebarProps {
  collapsed: boolean;
}

interface NavItem {
  path: string;
  icon: string;
  label: string;
  badge?: number;
}

const navItems: NavItem[] = [
  { path: '/dashboard', icon: 'fas fa-home', label: 'Dashboard' },
  { path: '/institutions', icon: 'fas fa-university', label: 'Institutions' },
  { path: '/groups', icon: 'fas fa-warehouse', label: 'Groups' },
  { path: '/users', icon: 'fas fa-users', label: 'Users' },
  { path: '/devices', icon: 'fas fa-laptop', label: 'Devices' },
  { path: '/labs', icon: 'fas fa-flask', label: 'Labs' },
  { path: '/certifications', icon: 'fas fa-certificate', label: 'Certifications' },
  { path: '/admin/rfid-tags', icon: 'fas fa-id-card', label: 'RFID Tags' },
  { path: '/streams', icon: 'fas fa-video', label: 'Streams' },
  { path: '/reports/hood-usage', icon: 'fas fa-chart-bar', label: 'Hood Usage' },
];

/**
 * Sidebar Component
 */
export const Sidebar: React.FC<SidebarProps> = ({ collapsed }) => {
  const { canAccessRoute } = usePermissions();

  const visibleItems = navItems.filter((item) => canAccessRoute(item.path));

  return (
    <aside
      className={`bg-dark text-white ${collapsed ? 'sidebar-collapsed' : 'sidebar-expanded'}`}
      style={{
        width: collapsed ? '60px' : '250px',
        transition: 'width 0.3s',
        minHeight: '100%',
      }}
    >
      <nav className="py-3">
        {visibleItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `d-flex align-items-center px-3 py-2 text-decoration-none ${
                isActive ? 'bg-primary text-white' : 'text-white-50 hover-bg-dark'
              }`
            }
            style={{ transition: 'all 0.2s' }}
          >
            <i className={`${item.icon} ${collapsed ? '' : 'me-3'}`} style={{ width: '20px' }}></i>
            {!collapsed && (
              <>
                <span>{item.label}</span>
                {item.badge && (
                  <span className="badge bg-danger ms-auto">{item.badge}</span>
                )}
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <style>{`
        .hover-bg-dark:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }
      `}</style>
    </aside>
  );
};

export default Sidebar;
